import { render, staticRenderFns } from "./RichEditor.vue?vue&type=template&id=5318969c&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"
import style1 from "./RichEditor.vue?vue&type=style&index=1&id=5318969c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5318969c",
  null
  
)

export default component.exports